function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.36 0H0.639998V10.5109H0V21.0219V24H4V21.0219H20V24H24V21.0219L24 10.5109H23.36V0ZM21.0399 2.54015H2.95987V7.9708H21.0399V2.54015ZM4.37956 12.0002C3.17018 12.0002 2.18978 12.9806 2.18978 14.19C2.18978 15.3994 3.17018 16.3798 4.37956 16.3798C5.58894 16.3798 6.56934 15.3994 6.56934 14.19C6.56934 12.9806 5.58894 12.0002 4.37956 12.0002ZM17.4307 14.19C17.4307 12.9806 18.4111 12.0002 19.6204 12.0002C20.8298 12.0002 21.8102 12.9806 21.8102 14.19C21.8102 15.3994 20.8298 16.3798 19.6204 16.3798C18.4111 16.3798 17.4307 15.3994 17.4307 14.19Z",
  fill: "currentColor"
});

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.6fecd349.svg";
export { ForwardRef as ReactComponent };